// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import Store from './store'
import App from './App'
import router from './router'
import VueResource from 'vue-resource'
import xiaoka from './xiaoka'
import Mint from 'mint-ui'
import Amap from 'vue-amap'
import './axios'
import cookieJS from 'js-cookie'
import Tool from './assets/js/method.js'
import Util from './assets/js/util.js'
import './filter'

Vue.use(VueResource)
Vue.use(xiaoka)
Vue.use(Mint)
Vue.use(Amap)

Vue.config.productionTip = false
Vue.prototype.$Cookie = cookieJS
Vue.prototype.$Tool = Tool
Vue.prototype.$Util = Util

Vue.http.interceptors.push((request, next) => {
  // modify request
  if(request.method == 'POST'){
    // continue to next interceptor
  　　next((response) => {//在响应之后传给then之前对response进行修改和逻辑判断。对于token时候已过期的判断，就添加在此处，页面中任何一次http请求都会先调用此处方法
  　　return response;
    });
  };
});

/* eslint-disable no-new */
new Vue({
  el: '#app',
  store: Store,
  router,
  template: '<App/>',
  components: {App}
})


// WEBPACK FOOTER //
// ./src/main.js